import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinktypesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-delete',
	path: '/secure/admin/DeleteLinkType!default.jspa',
};
